"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2806],{

/***/ 12744:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);



function Card(_a) {
    var children = _a.children, classes = _a.classes;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('card', classes) }, children);
}


//# sourceMappingURL=Card.js.map


/***/ }),

/***/ 8929:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ HamburgerIcon; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(36929);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/hamburger.icon.js


function hamburger_icon_HamburgerIcon() {
    return (react.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("mask", { id: "mask0_373_3819", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "24", height: "24" },
            react.createElement("rect", { width: "24", height: "24", fill: "#D9D9D9" })),
        react.createElement("g", { mask: "url(#mask0_373_3819)" },
            react.createElement("path", { d: "M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z", fill: "black" }))));
}


//# sourceMappingURL=hamburger.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/back-button.icon.js
var back_button_icon = __webpack_require__(34764);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/Icon.js
var Icon = __webpack_require__(21845);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Hamburger.js







function HamburgerIcon(_a) {
    var classes = _a.classes, onClick = _a.onClick, backButton = _a.backButton;
    var handleOnClick = function () {
        onClick && onClick();
    };
    var HamburgerIcon = (0,react.useCallback)(function (props) {
        if (backButton) {
            return react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ component: back_button_icon/* default */.Z }, props));
        }
        return react.createElement(Icon/* default */.Z, (0,tslib_es6/* __assign */.pi)({ component: hamburger_icon_HamburgerIcon }, props, { className: "hidden" }));
    }, [backButton]);
    return (react.createElement(HamburgerIcon, { onClick: handleOnClick, className: (0,classnames/* default */.Z)('hamburger', classes) }));
}


//# sourceMappingURL=Hamburger.js.map


/***/ }),

/***/ 72700:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HeaderLogo; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _LazyImage_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93791);



function HeaderLogo(_a) {
    var classes = _a.classes, webLogo = _a.webLogo, mobileLogo = _a.mobileLogo, onClick = _a.onClick, imageComponent = _a.imageComponent;
    var handleOnClick = function () {
        onClick && onClick();
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null,
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LazyImage_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { onClick: handleOnClick, classes: "header-logo--mobile ".concat(classes), src: mobileLogo || webLogo, alt: "brand-logo", imageComponent: imageComponent }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_LazyImage_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { onClick: handleOnClick, classes: "header-logo--web ".concat(classes), src: webLogo || mobileLogo, alt: "brand-logo", imageComponent: imageComponent })));
}


//# sourceMappingURL=HeaderLogo.js.map


/***/ }),

/***/ 7761:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ BottomNav; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/home.icon.js
var home_icon = __webpack_require__(77367);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/orders.icon.js
var orders_icon = __webpack_require__(93161);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/offers.icon.js


function OffersIcon() {
    return (react.createElement("svg", { width: "18", height: "18", viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M6.52779 11.5183L11.5312 6.52177L6.52779 11.5183Z", fill: "#313131" }),
        react.createElement("path", { d: "M6.52779 11.5183L11.5312 6.52177", stroke: "black", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react.createElement("path", { d: "M6.94734 7.35193C7.17746 7.35209 7.36414 7.16567 7.36429 6.93555C7.36445 6.70543 7.17803 6.51876 6.94792 6.5186C6.7178 6.51844 6.53112 6.70486 6.53096 6.93498C6.5308 7.1651 6.71722 7.35177 6.94734 7.35193Z", fill: "black", stroke: "black", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react.createElement("path", { d: "M11.1114 11.5214C11.3415 11.5216 11.5282 11.3352 11.5284 11.105C11.5285 10.8749 11.3421 10.6883 11.112 10.6881C10.8819 10.6879 10.6952 10.8744 10.695 11.1045C10.6949 11.3346 10.8813 11.5213 11.1114 11.5214Z", fill: "black", stroke: "black", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react.createElement("path", { d: "M9.02478 16.52C13.1669 16.5229 16.5271 13.1673 16.53 9.0252C16.5328 4.88306 13.1773 1.52288 9.03515 1.52002C4.89302 1.51715 1.53283 4.87269 1.52997 9.01483C1.52711 13.157 4.88265 16.5171 9.02478 16.52Z", stroke: "black", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}


//# sourceMappingURL=offers.icon.js.map

// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/profile-nav-icon.js


function ProfileNavIcon() {
    return (react.createElement("svg", { width: "21", height: "21", viewBox: "0 0 21 21", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M10.1195 1.68838C5.51697 1.6852 1.78355 5.41345 1.78037 10.0159C1.77719 14.6184 5.50544 18.3519 10.1079 18.355C14.7104 18.3582 18.4439 14.63 18.447 10.0275C18.4502 5.42497 14.722 1.69156 10.1195 1.68838Z", stroke: "#151515", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react.createElement("path", { d: "M3.66916 15.3054C3.66916 15.3054 5.5283 12.935 10.1116 12.9382C14.695 12.9414 16.5517 15.3143 16.5517 15.3143M10.1136 10.0215C10.7767 10.022 11.4128 9.75905 11.8819 9.29053C12.3511 8.82201 12.6149 8.18631 12.6154 7.52327C12.6158 6.86023 12.3529 6.22416 11.8844 5.755C11.4158 5.28583 10.7801 5.022 10.1171 5.02154C9.45406 5.02108 8.81799 5.28404 8.34883 5.75255C7.87966 6.22107 7.61583 6.85677 7.61537 7.51981C7.61491 8.18285 7.87787 8.81892 8.34638 9.28809C8.8149 9.75725 9.4506 10.0211 10.1136 10.0215V10.0215Z", stroke: "#151515", "stroke-width": "1.5", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}


//# sourceMappingURL=profile-nav-icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/framer-motion/dist/es/components/LazyMotion/index.js
var LazyMotion = __webpack_require__(71966);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/framer-motion/dist/es/render/dom/features-animation.js + 82 modules
var features_animation = __webpack_require__(75452);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/framer-motion/dist/es/render/dom/motion-minimal.js + 29 modules
var motion_minimal = __webpack_require__(47032);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Cells/BottomNav.js












function BottomNav(_a) {
    var items = _a.items, activePath = _a.activePath, onNavUpdate = _a.onNavUpdate;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var getNavIcon = function (type) {
        switch (type) {
            case 'home':
                return home_icon/* default */.Z;
            case 'profile':
                return ProfileNavIcon;
            case 'orders':
                return orders_icon/* default */.Z;
            case 'offers':
                return OffersIcon;
            default:
                return home_icon/* default */.Z;
        }
    };
    return (react.createElement("div", { className: "bottom-nav" },
        react.createElement(LazyMotion/* LazyMotion */.X, { features: features_animation/* domAnimation */.H }, items &&
            items.map(function (item, index) { return (react.createElement("div", { className: (0,classnames/* default */.Z)('bottom-nav__item', {
                    'bottom-nav__item--disabled': item === null || item === void 0 ? void 0 : item.disabled
                }), key: index, onClick: function () { return onNavUpdate(item.link); } },
                item.link === activePath && (react.createElement(motion_minimal.m.div, { layoutId: "bottom-nav-bar", className: "bottom-nav__item__border" })),
                react.createElement("div", { className: "bottom-nav__item__icon" }, getNavIcon(item.type)()),
                react.createElement("div", { className: "bottom-nav__item__label" },
                    react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain" }, item.title || t("common.".concat(item.label)))))); }))));
}


//# sourceMappingURL=BottomNav.js.map


/***/ }),

/***/ 23185:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ index_component; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);



function HeaderBase(_a) {
    var classes = _a.classes, children = _a.children;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('header', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "header-container" }, children)));
}
function HeaderLeft(_a) {
    var classes = _a.classes, children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('header-left', classes) }, children);
}
function HeaderRight(_a) {
    var classes = _a.classes, children = _a.children;
    return react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('header-right', classes) }, children);
}
var index_component = {
    HeaderBase: HeaderBase,
    HeaderLeft: HeaderLeft,
    HeaderRight: HeaderRight
};


//# sourceMappingURL=Header.js.map


/***/ }),

/***/ 9094:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NavDrawer; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Atoms_Divider_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36548);
/* harmony import */ var _Molecules_Drawer_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77976);
/* harmony import */ var _Molecules_NavMenu_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98198);
/* harmony import */ var _Molecules_UserCard_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20973);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87637);







function NavDrawer(_a) {
    var classes = _a.classes, open = _a.open, onClose = _a.onClose, user = _a.user, onLoginCallback = _a.onLoginCallback, onEditProfileCallback = _a.onEditProfileCallback, menuLinks = _a.menuLinks, onLogoutCallback = _a.onLogoutCallback;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Molecules_Drawer_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { open: open, onClose: onClose, classes: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)('nav-drawer-card', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "nav-drawer" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Molecules_UserCard_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, { onLoginCallback: onLoginCallback, onEditProfileCallback: onEditProfileCallback, user: user, classes: "nav-drawer-user-card" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Divider_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { classes: "nav-drawer-divider", dividerStyle: 'solid', variant: 'horizontal', thickness: "thin" }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Molecules_NavMenu_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, { menuLinks: menuLinks, onLogoutCallback: onLogoutCallback }))));
}


//# sourceMappingURL=NavDrawer.js.map


/***/ }),

/***/ 87982:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ DrawerDirection; }
/* harmony export */ });
var DrawerDirection;
(function (DrawerDirection) {
    DrawerDirection["left"] = "left";
    DrawerDirection["right"] = "right";
})(DrawerDirection || (DrawerDirection = {}));


//# sourceMappingURL=web.interface.js.map


/***/ }),

/***/ 77976:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Drawer; }
/* harmony export */ });
/* harmony import */ var _external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36929);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Components_Molecules_Drawer_Web_web_interface_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87982);
/* harmony import */ var _Atoms_Card_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12744);
/* harmony import */ var _Atoms_Portal_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(81718);
/* harmony import */ var _external_lib_framer_motion_dist_es_components_LazyMotion_index_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71966);
/* harmony import */ var _external_lib_framer_motion_dist_es_render_dom_features_animation_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(75452);
/* harmony import */ var _external_lib_framer_motion_dist_es_render_dom_motion_minimal_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(47032);










function Drawer(_a) {
    var children = _a.children, open = _a.open, onClose = _a.onClose, direction = _a.direction, classes = _a.classes;
    var _b = react__WEBPACK_IMPORTED_MODULE_0__.useState(open), _isOpen = _b[0], setIsOpen = _b[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () { return setIsOpen(open); }, [open]);
    var animation = {
        open: {
            opacity: 0.9
        },
        closed: {
            opacity: 0
        }
    };
    var leftRightAnimation = { open: { opacity: 1 }, closed: {} };
    leftRightAnimation['open'][direction || _Components_Molecules_Drawer_Web_web_interface_js__WEBPACK_IMPORTED_MODULE_2__/* .DrawerDirection.left */ .j.left] = 0;
    leftRightAnimation['closed'][direction || _Components_Molecules_Drawer_Web_web_interface_js__WEBPACK_IMPORTED_MODULE_2__/* .DrawerDirection.left */ .j.left] = '-100%';
    var _onClose = function () {
        setIsOpen(false);
        if (typeof onClose === "function") {
            onClose();
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Portal_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, null, _isOpen && (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('drawer', classes) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_external_lib_framer_motion_dist_es_components_LazyMotion_index_js__WEBPACK_IMPORTED_MODULE_5__/* .LazyMotion */ .X, { features: _external_lib_framer_motion_dist_es_render_dom_features_animation_js__WEBPACK_IMPORTED_MODULE_6__/* .domAnimation */ .H },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_external_lib_framer_motion_dist_es_render_dom_motion_minimal_js__WEBPACK_IMPORTED_MODULE_7__.m.div, { className: "drawer__backdrop", animate: animation.open, initial: animation.closed, exit: animation.closed, onClick: _onClose, transition: { type: 'tween' } }),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_external_lib_framer_motion_dist_es_render_dom_motion_minimal_js__WEBPACK_IMPORTED_MODULE_7__.m.div, { className: "drawer__card", animate: (0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__/* .__assign */ .pi)((0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__/* .__assign */ .pi)({}, animation.open), leftRightAnimation.open), initial: (0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__/* .__assign */ .pi)((0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__/* .__assign */ .pi)({}, animation.closed), leftRightAnimation.closed), exit: (0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__/* .__assign */ .pi)((0,_external_lib_tslib_tslib_es6_js__WEBPACK_IMPORTED_MODULE_8__/* .__assign */ .pi)({}, animation.closed), leftRightAnimation.closed), key: "drawer", transition: { type: 'tween' } },
                react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Card_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null, children)))))));
}


//# sourceMappingURL=Drawer.js.map


/***/ }),

/***/ 22888:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ LanguageWidget; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/language.icon.js


function LanguageIcon() {
    return (react.createElement("svg", { width: "18", height: "19", viewBox: "0 0 18 19", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M2.25 3.6875H8.15625M6.46875 2V3.6875C6.46875 7.41519 4.57959 10.4375 2.25 10.4375", stroke: "#151515", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" }),
        react.createElement("path", { d: "M3.09375 7.0625C3.09122 8.8715 5.5845 10.3599 8.74688 10.4375M9 16.3438L12.375 8.75L15.75 16.3438M14.9906 14.6562H9.75938", stroke: "#151515", strokeWidth: "1.6", strokeLinecap: "round", strokeLinejoin: "round" })));
}


//# sourceMappingURL=language.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Divider.js
var Divider = __webpack_require__(36548);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/down-arrow.icon.js
var down_arrow_icon = __webpack_require__(56088);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/LanguageWidget.js







function LanguageWidget(_a) {
    var _b;
    var classes = _a.classes, _c = _a.languages, languages = _c === void 0 ? [{ name: 'En', code: 'en' }] : _c, onLanguageChange = _a.onLanguageChange, activeLanguage = _a.activeLanguage; _a.isMobile;
    var activeLanguageText = (_b = languages.find(function (lang) { return lang.code === activeLanguage; })) === null || _b === void 0 ? void 0 : _b.name;
    var handleOnLanguageChange = function (code) {
        onLanguageChange && onLanguageChange(code);
    };
    return (react.createElement("div", { className: (0,classnames/* default */.Z)('language-widget', classes) },
        react.createElement(LanguageIcon, { className: "language-widget__icon" }),
        react.createElement(Typography/* default */.Z, { classes: "language-widget__active-language", variant: "bodyTextOneMain" }, activeLanguageText),
        react.createElement(down_arrow_icon/* default */.Z, { className: "language-widget__down-icon" }),
        react.createElement("div", { className: "language-widget__popover" }, languages.map(function (lang, index) { return (react.createElement(react.Fragment, { key: lang.code },
            react.createElement(Typography/* default */.Z, { classes: (0,classnames/* default */.Z)('language-widget__lang', {
                    'language-widget__lang--active': lang.code === activeLanguage
                }), variant: "bodyTextOneMain", onClickCallback: function () { return handleOnLanguageChange(lang.code); } }, lang.name),
            index !== languages.length - 1 && (react.createElement(Divider/* default */.Z, { classes: "language-widget__popover__divider", dividerStyle: 'solid', variant: 'horizontal', size: "100%" })))); }))));
}


//# sourceMappingURL=LanguageWidget.js.map


/***/ }),

/***/ 98198:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ NavMenu; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Atoms/Typography.js
var Typography = __webpack_require__(87427);
// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/classnames/index.js
var classnames = __webpack_require__(87637);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/menu.icon.js


function MenuIcon() {
    return (react.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { className: "nav-icon", d: "M12.5 6.559V7.00644L12.9447 7.05593C17.188 7.52815 20.5 11.1333 20.5 15.5V17H3.5V15.5C3.5 11.1333 6.81197 7.52815 11.0553 7.05593L11.5 7.00644V6.559V5H12.5V6.559ZM4.5 15.5V16H5H19H19.5V15.5C19.5 11.3649 16.1351 8 12 8C7.86486 8 4.5 11.3649 4.5 15.5ZM21.5 19V20H2.5V19H21.5Z", fill: "#1A18AF", stroke: "#1A18AF" })));
}


//# sourceMappingURL=menu.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/orders.icon.js
var orders_icon = __webpack_require__(93161);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/logout.icon.js


function LogoutIcon() {
    return (react.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M5 5H4.5V5.5V19.5V20H5H11.5V21H5C4.17614 21 3.5 20.3239 3.5 19.5V5.5C3.5 4.67614 4.17614 4 5 4H11.5V5H5ZM17 12H17.5V11.5V9.70711L20.2929 12.5L17.5 15.2929V13.5V13H17H9.5V12H17Z", fill: "#151515", stroke: "#151515" })));
}


//# sourceMappingURL=logout.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/custom-page.icon.js


function CustomPageIcon() {
    return (react.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M5 5H4.5V5.5V19.5V20H5H11.5V21H5C4.17614 21 3.5 20.3239 3.5 19.5V5.5C3.5 4.67614 4.17614 4 5 4H11.5V5H5ZM17 12H17.5V11.5V9.70711L20.2929 12.5L17.5 15.2929V13.5V13H17H9.5V12H17Z", fill: "#151515", stroke: "#151515" })));
}


//# sourceMappingURL=custom-page.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/lib/components/Icon.js + 1 modules
var Icon = __webpack_require__(4610);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/fav-nav-icon.icon.js


function FavouriteNavIcon() {
    return (react.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M7.5 4.5C4.4625 4.5 2 6.9625 2 10C2 15.5 8.5 20.5 12 21.663C15.5 20.5 22 15.5 22 10C22 6.9625 19.5375 4.5 16.5 4.5C14.64 4.5 12.995 5.4235 12 6.837C11.4928 6.1146 10.8191 5.52505 10.0358 5.11824C9.25245 4.71144 8.38265 4.49938 7.5 4.5Z", stroke: "#151515", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}


//# sourceMappingURL=fav-nav-icon.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/offer-nav-icon.icon.js


function OfferNavIcon() {
    return (react.createElement("svg", { width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M7.00729 13.4595L6.5394 12.9916L12.9906 6.54038L13.4585 7.00827L7.00729 13.4595ZM17.0533 10.2266L18.3094 12.6965L15.8067 13.9621L15.5784 14.0775L15.5384 14.3302L15.108 17.0536L12.3598 16.6226L12.1085 16.5832L11.9287 16.763L9.97586 18.7159L8.01274 16.7316L7.83076 16.5477L7.57551 16.59L4.8552 17.041L4.41773 14.2962L4.3777 14.0451L4.15113 13.9295L1.6877 12.6731L2.94463 10.2016L3.06008 9.9746L2.94436 9.74774L1.69555 7.29951L4.17812 6.01933L4.40283 5.90345L4.4427 5.65378L4.87195 2.96569L7.60195 3.41011L7.85614 3.45148L8.03742 3.26857L10.0002 1.28812L11.9451 3.2365L12.1249 3.41667L12.3764 3.37723L15.1247 2.94627L15.5551 5.66965L15.5949 5.92129L15.8218 6.03702L18.3029 7.30231L17.0528 9.77429L16.9383 10.0006L17.0533 10.2266ZM17.1972 8.02983L17.4131 7.59305L16.982 7.36592L15.033 6.33894L14.6583 4.17303L14.5754 3.69371L14.094 3.76343L11.9201 4.07827L10.3465 2.55711L9.99896 2.22118L9.65145 2.55711L8.07783 4.07827L5.90396 3.76343L5.42254 3.69371L5.33961 4.17303L4.96489 6.33894L3.01587 7.36592L2.58483 7.59305L2.80073 8.02983L3.77454 9.99994L2.80073 11.97L2.58483 12.4068L3.01587 12.634L4.96489 13.6609L5.33961 15.8268L5.42254 16.3062L5.90396 16.2364L8.07783 15.9216L9.65145 17.4428L9.99896 17.7787L10.3465 17.4428L11.9201 15.9216L14.094 16.2364L14.5754 16.3062L14.6583 15.8268L15.033 13.6609L16.982 12.634L17.4131 12.4068L17.1972 11.97L16.2234 9.99994L17.1972 8.02983ZM7.91562 6.33327C8.33115 6.33327 8.66562 6.66774 8.66562 7.08327C8.66562 7.49879 8.33115 7.83327 7.91562 7.83327C7.5001 7.83327 7.16562 7.49879 7.16562 7.08327C7.16562 6.66774 7.5001 6.33327 7.91562 6.33327ZM12.0823 12.1666C12.4978 12.1666 12.8323 12.5011 12.8323 12.9166C12.8323 13.3321 12.4978 13.6666 12.0823 13.6666C11.6668 13.6666 11.3323 13.3321 11.3323 12.9166C11.3323 12.5011 11.6668 12.1666 12.0823 12.1666Z", fill: "#151515", stroke: "#151515" })));
}


//# sourceMappingURL=offer-nav-icon.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/wallet-nav-icon.icon.js


function WalletNavIcon() {
    return (react.createElement("svg", { width: "24", height: "25", viewBox: "0 0 24 25", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M11.931 2.55769C12.0548 2.40273 12.2082 2.27387 12.3822 2.17858C12.5561 2.08328 12.7473 2.02344 12.9445 2.00251C13.1418 1.98158 13.3412 1.99999 13.5313 2.05667C13.7214 2.11334 13.8984 2.20716 14.052 2.33269L18.945 6.32869C19.2141 6.54839 19.3986 6.85469 19.467 7.19528C19.5354 7.53587 19.4834 7.88963 19.32 8.19619C18.8922 8.06544 18.4473 7.99922 18 7.99969H17.55L17.997 7.48969L15.42 5.38519L13.2945 8.00119H11.361L14.2575 4.43719L13.1025 3.49369L9.5055 7.99969H7.5855L11.931 2.55769ZM15.75 15.4997C15.5511 15.4997 15.3603 15.5787 15.2197 15.7194C15.079 15.86 15 16.0508 15 16.2497C15 16.4486 15.079 16.6394 15.2197 16.78C15.3603 16.9207 15.5511 16.9997 15.75 16.9997H17.25C17.4489 16.9997 17.6397 16.9207 17.7803 16.78C17.921 16.6394 18 16.4486 18 16.2497C18 16.0508 17.921 15.86 17.7803 15.7194C17.6397 15.5787 17.4489 15.4997 17.25 15.4997H15.75ZM4.5 8.74969C4.5 8.55078 4.57902 8.36001 4.71967 8.21936C4.86032 8.07871 5.05109 7.99969 5.25 7.99969H6.087L7.2795 6.49969H5.25C4.65326 6.49969 4.08097 6.73674 3.65901 7.1587C3.23705 7.58065 3 8.15295 3 8.74969V17.7497C3 18.7442 3.39509 19.6981 4.09835 20.4013C4.80161 21.1046 5.75544 21.4997 6.75 21.4997H18C18.7956 21.4997 19.5587 21.1836 20.1213 20.621C20.6839 20.0584 21 19.2953 21 18.4997V12.4997C21 11.704 20.6839 10.941 20.1213 10.3784C19.5587 9.81576 18.7956 9.49969 18 9.49969H5.25C5.05109 9.49969 4.86032 9.42067 4.71967 9.28002C4.57902 9.13937 4.5 8.9486 4.5 8.74969ZM4.5 17.7497V10.8722C4.734 10.9547 4.9875 10.9997 5.25 10.9997H18C18.3978 10.9997 18.7794 11.1577 19.0607 11.439C19.342 11.7203 19.5 12.1019 19.5 12.4997V18.4997C19.5 18.8975 19.342 19.279 19.0607 19.5603C18.7794 19.8417 18.3978 19.9997 18 19.9997H6.75C6.15326 19.9997 5.58097 19.7626 5.15901 19.3407C4.73705 18.9187 4.5 18.3464 4.5 17.7497Z", fill: "#151515", stroke: "#151515", "stroke-width": "0.4" })));
}


//# sourceMappingURL=wallet-nav-icon.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/refer-nav-icon.icon.js


function ReferNavIcon() {
    return (react.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M22 9V7H20V9H18V11H20V13H22V11H24V9H22ZM8 12C10.21 12 12 10.21 12 8C12 5.79 10.21 4 8 4C5.79 4 4 5.79 4 8C4 10.21 5.79 12 8 12ZM8 6C9.1 6 10 6.9 10 8C10 9.1 9.1 10 8 10C6.9 10 6 9.1 6 8C6 6.9 6.9 6 8 6ZM8 13C5.33 13 0 14.34 0 17V20H16V17C16 14.34 10.67 13 8 13ZM14 18H2V17.01C2.2 16.29 5.3 15 8 15C10.7 15 13.8 16.29 14 17V18ZM12.51 4.05C13.43 5.11 14 6.49 14 8C14 9.51 13.43 10.89 12.51 11.95C14.47 11.7 16 10.04 16 8C16 5.96 14.47 4.3 12.51 4.05ZM16.53 13.83C17.42 14.66 18 15.7 18 17V20H20V17C20 15.55 18.41 14.49 16.53 13.83Z", fill: "black" })));
}


//# sourceMappingURL=refer-nav-icon.icon.js.map

;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/assets/icons/address-nav-icon.icon.js


function AddressNavIcon() {
    return (react.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react.createElement("path", { d: "M12 13C13.6569 13 15 11.6569 15 10C15 8.34315 13.6569 7 12 7C10.3431 7 9 8.34315 9 10C9 11.6569 10.3431 13 12 13Z", stroke: "#151515", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react.createElement("path", { d: "M12 2C9.87827 2 7.84344 2.84285 6.34315 4.34315C4.84285 5.84344 4 7.87827 4 10C4 11.892 4.402 13.13 5.5 14.5L12 22L18.5 14.5C19.598 13.13 20 11.892 20 10C20 7.87827 19.1571 5.84344 17.6569 4.34315C16.1566 2.84285 14.1217 2 12 2V2Z", stroke: "#151515", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}


//# sourceMappingURL=address-nav-icon.icon.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/icons/RightOutlined.js + 1 modules
var RightOutlined = __webpack_require__(44496);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/Molecules/NavMenu.js
















function NavMenu(_a) {
    var menuLinks = _a.menuLinks, onLogoutCallback = _a.onLogoutCallback;
    var _b = (0,react.useState)(0), selectedLink = _b[0], setSelectedLink = _b[1];
    var t = (0,useTranslation/* useTranslation */.$)().t;
    return (react.createElement("div", { className: "nav-menu" }, menuLinks.map(function (link, index) {
        if (link.isEnabled && link.link !== '/logout') {
            return (react.createElement("a", { onClick: function () { return setSelectedLink(index); }, href: link.link, key: index, className: (0,classnames/* default */.Z)('nav-menu__link', {
                    selected: selectedLink === index
                }) },
                react.createElement("div", { className: "nav-menu__link__container" },
                    react.createElement("div", { className: "nav-menu__link__icon" },
                        react.createElement(NavIcon, { path: link.link, selected: true }),
                        react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain", classes: "nav-menu__link__label" }, link.label)),
                    react.createElement(RightOutlined/* default */.Z, null))));
        }
        else if (link.isEnabled && link.link === '/logout') {
            return (react.createElement("a", { onClick: onLogoutCallback, key: index, className: (0,classnames/* default */.Z)('nav-menu-logout-link nav-menu__link', {
                    selected: selectedLink === index
                }) },
                react.createElement("div", { className: "nav-menu__link__container" },
                    react.createElement("div", { className: "nav-menu__link__icon" },
                        react.createElement(NavIcon, { path: link.link, selected: true }),
                        react.createElement(Typography/* default */.Z, { variant: "bodyTextOneMain", classes: "nav-menu__link__label" }, t('sidebar.logout'))),
                    react.createElement(RightOutlined/* default */.Z, null))));
        }
    })));
}
function NavIcon(_a) {
    var path = _a.path, _b = _a.selected, selected = _b === void 0 ? false : _b;
    switch (path) {
        case '/menu':
            return (react.createElement(Icon/* default */.Z, { className: (0,classnames/* default */.Z)('nav-menu__nav-icon', {
                    'nav-menu__nav-icon--selected': selected
                }), component: MenuIcon }));
        case '/orders':
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: orders_icon/* default */.Z });
        case '/favourites':
            return (react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: FavouriteNavIcon }));
        case '/wallet':
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: WalletNavIcon });
        case '/refer':
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: ReferNavIcon });
        case '/address':
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: AddressNavIcon });
        case '/offers':
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: OfferNavIcon });
        case '/logout':
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: LogoutIcon });
        default:
            return react.createElement(Icon/* default */.Z, { className: "nav-menu__nav-icon", component: CustomPageIcon });
    }
}


//# sourceMappingURL=NavMenu.js.map


/***/ }),

/***/ 65779:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ SearchCta; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87637);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(87427);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26793);
/* harmony import */ var _assets_icons_search_cta_icon_icon_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2717);






function SearchCta(_a) {
    var onClick = _a.onClick, classes = _a.classes; _a.isMobile; var isActive = _a.isActive;
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_4__/* .useTranslation */ .$)().t;
    var handleOnClick = function () {
        onClick && onClick();
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)('search-cta', classes, {
            'search-cta--active': isActive
        }), onClick: handleOnClick },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_assets_icons_search_cta_icon_icon_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, null),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "search-cta__text", variant: "bodyTextOneMain" }, t('header.search'))));
}


//# sourceMappingURL=SearchCta.js.map


/***/ }),

/***/ 20973:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ UserCard; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87427);
/* harmony import */ var _Atoms_Button_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66693);
/* harmony import */ var _external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87637);





function UserCard(_a) {
    var user = _a.user, onLoginCallback = _a.onLoginCallback, onEditProfileCallback = _a.onEditProfileCallback;
    var onCtaClick = function () {
        if (user) {
            onEditProfileCallback === null || onEditProfileCallback === void 0 ? void 0 : onEditProfileCallback();
        }
        else {
            onLoginCallback === null || onLoginCallback === void 0 ? void 0 : onLoginCallback();
        }
    };
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: (0,_external_lib_classnames_index_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)('user-card', { loggedin: user }) },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "user-card__image" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { classes: "user-card__image__text", variant: "headingOne" }, user ? user.name[0].toUpperCase() : 'G')),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "user-card__details" },
            react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { classes: "user-card__details__name", variant: "headingTwo" }, user ? user.name : 'Guest'),
            react__WEBPACK_IMPORTED_MODULE_0__.createElement("div", { className: "user-card__details__bottom" },
                (user === null || user === void 0 ? void 0 : user.phone) ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Typography_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, { variant: "bodyTextOne" }, user.phone)) : null,
                !(user === null || user === void 0 ? void 0 : user.is_guest_checkout) ? (react__WEBPACK_IMPORTED_MODULE_0__.createElement(_Atoms_Button_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, { classes: "user-card__details__cta", variant: 'link', size: 'md', onClick: onCtaClick }, user ? 'Edit profile' : 'Login')) : null))));
}


//# sourceMappingURL=UserCard.js.map


/***/ }),

/***/ 34764:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ BackButton; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function BackButton() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "12", height: "20", viewBox: "0 0 12 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M10 20L0 10L10 0L11.775 1.775L3.55 10L11.775 18.225L10 20Z", fill: "black" })));
}


//# sourceMappingURL=back-button.icon.js.map


/***/ }),

/***/ 77367:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ HomeIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function HomeIcon() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "17", height: "18", viewBox: "0 0 17 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M9.23904 0.90812C9.16157 0.830013 9.0694 0.768017 8.96785 0.72571C8.8663 0.683403 8.75738 0.661621 8.64737 0.661621C8.53736 0.661621 8.42844 0.683403 8.32689 0.72571C8.22534 0.768017 8.13317 0.830013 8.0557 0.90812L0.555703 8.40812C0.477596 8.48559 0.4156 8.57776 0.373293 8.67931C0.330986 8.78086 0.309204 8.88978 0.309204 8.99979C0.309204 9.1098 0.330986 9.21872 0.373293 9.32027C0.4156 9.42182 0.477596 9.51398 0.555703 9.59145C0.633569 9.66869 0.725916 9.72979 0.827447 9.77126C0.928978 9.81273 1.0377 9.83375 1.14737 9.83312H1.9807V15.6665C1.9807 16.1085 2.1563 16.5324 2.46886 16.845C2.78142 17.1575 3.20534 17.3331 3.64737 17.3331H13.6474C14.0894 17.3331 14.5133 17.1575 14.8259 16.845C15.1384 16.5324 15.314 16.1085 15.314 15.6665V9.83312H16.1474C16.3684 9.83312 16.5803 9.74532 16.7366 9.58904C16.8929 9.43276 16.9807 9.2208 16.9807 8.99979C16.9813 8.89011 16.9603 8.7814 16.9188 8.67986C16.8774 8.57833 16.8163 8.48599 16.739 8.40812L9.23904 0.90812ZM3.64737 15.6665V7.67479L8.64737 2.67479L13.6474 7.67479V15.6665H3.64737Z", fill: "black" })));
}


//# sourceMappingURL=home.icon.js.map


/***/ }),

/***/ 93161:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ OrdersIcon; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);


function OrdersIcon() {
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", { width: "17", height: "18", viewBox: "0 0 17 18", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M16.071 9.02691L16.0753 2.77691C16.0755 2.44539 15.9441 2.12736 15.7098 1.89277C15.4755 1.65819 15.1577 1.52628 14.8262 1.52605L2.32617 1.5174C1.99465 1.51718 1.67662 1.64865 1.44204 1.88291C1.20745 2.11717 1.07554 2.43502 1.07531 2.76654L1.06667 15.2665C1.06644 15.5981 1.19791 15.9161 1.43217 16.1507C1.66643 16.3853 1.98428 16.5172 2.3158 16.5174L8.5658 16.5217", stroke: "black", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M11.9008 14.8574C13.2816 14.8583 14.4016 13.7398 14.4026 12.3591C14.4035 10.9784 13.285 9.85833 11.9043 9.85738C10.5236 9.85643 9.40352 10.9749 9.40257 12.3557C9.40161 13.7364 10.5201 14.8564 11.9008 14.8574Z", stroke: "black", "stroke-width": "1.6" }),
        react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", { d: "M13.9838 14.0254L16.066 15.6935M4.40625 5.68549L12.7396 5.69125M4.40395 9.01882L7.73728 9.02112", stroke: "black", "stroke-width": "1.6", "stroke-linecap": "round", "stroke-linejoin": "round" })));
}


//# sourceMappingURL=orders.icon.js.map


/***/ }),

/***/ 44496:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ RightOutlined$1; }
});

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(38947);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons-svg/es/asn/RightOutlined.js
// This icon file is generated automatically.
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlinedSvg = RightOutlined;


//# sourceMappingURL=RightOutlined.js.map

// EXTERNAL MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/components/AntdIcon.js + 8 modules
var AntdIcon = __webpack_require__(6221);
;// CONCATENATED MODULE: ./node_modules/@urbanpiper-engineering/meraki-components/dist/external_lib/@ant-design/icons/es/icons/RightOutlined.js





var RightOutlined_RightOutlined = function RightOutlined(props, ref) {
  return /*#__PURE__*/react.createElement(AntdIcon/* default */.Z, (0,objectSpread2/* default */.Z)((0,objectSpread2/* default */.Z)({}, props), {}, {
    ref: ref,
    icon: RightOutlinedSvg
  }));
};
RightOutlined_RightOutlined.displayName = 'RightOutlined';
var RightOutlined$1 = /*#__PURE__*/react.forwardRef(RightOutlined_RightOutlined);


//# sourceMappingURL=RightOutlined.js.map


/***/ })

}]);